import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { TypingType } from '@/types/events/typing';

export default function stopTyping(data: TypingType): void {
  const conversationsStore = useConversationsStore();
  conversationsStore.removeTypingUser(data);
}
